export const CV_REQUEST = 'CV_REQUEST'
export const CV_SUCCESS = 'CV_SUCCESS'
export const CV_FAIL = 'CV_FAIL'

export const COMPETENCES_REQUEST = 'COMPETENCES_REQUEST'
export const COMPETENCES_SUCCESS = 'COMPETENCES_SUCCESS'
export const COMPETENCES_FAIL = 'COMPETENCES_FAIL'

export const PUBLICATIONS_REQUEST = 'PUBLICATIONS_REQUEST'
export const PUBLICATIONS_SUCCESS = 'PUBLICATIONS_SUCCESS'
export const PUBLICATIONS_FAIL = 'PUBLICATIONS_FAIL'

export const HONORS_REQUEST = 'HONORS_REQUEST'
export const HONORS_SUCCESS = 'HONORS_SUCCESS'
export const HONORS_FAIL = 'HONORS_FAIL'

export const CONTACT_REQUEST = 'CONTACT_REQUEST'
export const CONTACT_SUCCESS = 'CONTACT_SUCCESS'
export const CONTACT_FAIL = 'CONTACT_FAIL'
